import React from 'react'
import { EditIcon } from '@instacart/ids-core'
import { useDomainMessage } from 'domains/account-management/utils/domain/intl'
import { useGoToAccountManagementPage } from 'domains/account-management/utils/useGoToAccountManagementPage.hooks'
import { Button, Tooltip } from '@retailer-platform/shared-components'
import { accountButtonStyle } from 'domains/account-management/components/accounts-list/components/list/ListAccountsGridList'

interface Props {
  accountCanonicalId: string
}

export const EditAccountButton: React.FunctionComponent<Props> = ({
  accountCanonicalId,
  ...props
}) => {
  const goToEditAccount = useGoToAccountManagementPage({ accountCanonicalId })

  const editMessage = useDomainMessage('accountManagementDomain.list.edit')

  return (
    <Tooltip
      placement="bottom"
      target={
        <Button
          variant={'tertiary'}
          compact={true}
          onClick={goToEditAccount}
          data-testid={props['data-testid']}
          css={accountButtonStyle}
        >
          <EditIcon size={16} color="systemGrayscale70" />
        </Button>
      }
    >
      {editMessage}
    </Tooltip>
  )
}
